export default __webpack_public_path__ + "static/ni-e78c1b2a6eb17bbe0c175b35a4eb66ca.svg";